<template>
  <div class="container">
    <HeadingOne class="-margin-md">秘密のことば設定</HeadingOne>

    <ErrorsAlert
      :errors="errors"
      :column-only="true"
      :items="inputItemsEn"
    ></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="0" type="secret"></MainWizard>
    </WizardGroup>

    <p>
      暗証番号の変更など、お取引時にご本人さま確認をさせていただくための秘密のことばの設定をおこなってください。<br />
      質問を選択し、それに対する答えを入力してください。
    </p>

    <ListGroup class="-note">
      <ListItem class="-note"
        >秘密のことばは、第三者に知られないよう十分にご注意ください。</ListItem
      >
      <ListItem class="-note">必須の項目は必ずご入力ください。</ListItem>
    </ListGroup>

    <form novalidate @submit.prevent="submitValidateSecretQuestions()">
      <section>
        <TableGroup>
          <TableBox class="-entry _mb-sm-20 _mb-md-30">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">質問1</TableHeader>
                <TableData :has-error="errors['secret_word_ask1']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ask1']"
                  >
                    <BtnSelect
                      id="secret_word_ask1"
                      v-model="userData.secret_word_ask1"
                      class="form-control"
                    >
                      <option
                        v-for="(secretWordAsk, index) in secretWordAsks"
                        :key="'secretWordAsk1' + index + 1"
                        :value="secretWordAsk['value']"
                      >
                        {{ secretWordAsk["name"] }}
                      </option>
                    </BtnSelect>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >質問1の答え<small class="moji"
                    >【全角ひらがな、30文字以内】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['secret_word_ans1']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ans1']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="secret_word_ans1"
                        v-model="userData.secret_word_ans1"
                        type="text"
                        class="-lg"
                        :maxlength="30"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>

          <TableBox class="-entry _mb-sm-20 _mb-md-30">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">質問2</TableHeader>
                <TableData :has-error="errors['secret_word_ask2']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ask2']"
                  >
                    <BtnSelect
                      id="secret_word_ask2"
                      v-model="userData.secret_word_ask2"
                      class="form-control"
                    >
                      <option
                        v-for="(secretWordAsk, index) in secretWordAsks"
                        :key="'secretWordAsk2' + index + 1"
                        :value="secretWordAsk['value']"
                      >
                        {{ secretWordAsk["name"] }}
                      </option>
                    </BtnSelect>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >質問2の答え<small class="moji"
                    >【全角ひらがな、30文字以内】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['secret_word_ans2']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ans2']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="secret_word_ans2"
                        v-model="userData.secret_word_ans2"
                        type="text"
                        class="-lg"
                        :maxlength="30"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>

          <TableBox class="-entry _mb-sm-20 _mb-md-30">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">質問3</TableHeader>
                <TableData :has-error="errors['secret_word_ask3']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ask3']"
                  >
                    <BtnSelect
                      id="secret_word_ask3"
                      v-model="userData.secret_word_ask3"
                      class="form-control"
                    >
                      <option
                        v-for="(secretWordAsk, index) in secretWordAsks"
                        :key="'secretWordAsk3' + index + 1"
                        :value="secretWordAsk['value']"
                      >
                        {{ secretWordAsk["name"] }}
                      </option>
                    </BtnSelect>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >質問3の答え<small class="moji"
                    >【全角ひらがな、30文字以内】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['secret_word_ans3']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ans3']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="secret_word_ans3"
                        v-model="userData.secret_word_ans3"
                        type="text"
                        class="-lg"
                        :maxlength="30"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
      </section>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="submitValidateSecretQuestions">
          確認画面へ
        </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  validateSecretQuestionsLambdaInvoke,
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { secretWordAsks, inputItemsEn } from "@/constants/constant";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import BtnSelect from "@/components/button/BtnSelect";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputItem from "@/components/input/InputItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "En015",
  components: {
    BtnMain,
    BtngroupSingle,
    InputItem,
    InputgroupAppend,
    BtnSelect,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    ListItem,
    ListGroup,
    ErrorsAlert,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "秘密のことば設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,秘密のことば",
    });
  },
  data() {
    return {
      errors: {},
      secretWordAsks: secretWordAsks,
      isDisabled: false,
      userData: {
        secret_word_ask1: "00",
        secret_word_ans1: "",
        secret_word_ask2: "00",
        secret_word_ans2: "",
        secret_word_ask3: "00",
        secret_word_ans3: "",
      },
      inputItemsEn: inputItemsEn,
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitValidateSecretQuestions() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            validateSecretQuestionsLambdaInvoke(this.userData)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "en016" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
